import React, { createContext, useContext, ReactNode, useState } from "react";
import { NavigationBar } from "./navigation-bar";
import styles from "./navigation-bar.module.css";
import type { Session, SupabaseClient } from "@supabase/supabase-js";
type Role = "admin" | "user";

type NavigationBarContextType = {
  setNavbarHidden: (hidden: boolean) => void;
};

const NavigationBarContext = createContext<
  NavigationBarContextType | undefined
>(undefined);

interface NavigationBarProviderProps {
  children: ReactNode;
}

export const NavigationBarProvider = (props: NavigationBarProviderProps) => {
  const [isNavbarHidden, setIsNavbarHidden] = useState(false);

  return (
    <NavigationBarContext.Provider value={{ setNavbarHidden: setIsNavbarHidden }}>
      {!isNavbarHidden && <NavigationBar />}
      <div className={styles.appContent}>{props.children}</div>
    </NavigationBarContext.Provider>
  );
};

export const useNavigationBarContext = (): NavigationBarContextType => {
  const context = useContext(NavigationBarContext);
  if (!context) {
    throw new Error(
      "useNavigationBarContext must be used within an NavigationBarProvider"
    );
  }
  return context;
};
